// Narration / captions for "Mission Memory". One ScriptLine[] per scene, scene-LOCAL
// seconds. caption == the spoken line. House rule for this episode: NO long hyphens
// (no em dashes) anywhere in the copy. Sentences use commas and periods instead.
import type { ScriptLine } from "../../coldcompute";

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "Your AI did the work. Then it forgot the work ever happened." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 6, caption: "A mission runs and generates a whole stack of content ideas." },
  { scene: "problem", fromSec: 6.6, holdSec: 6, caption: "It emails them to you, and then those ideas fall into a drawer nobody can search." },
  { scene: "problem", fromSec: 12.8, holdSec: 6, caption: "Weeks later you ask the chat, what ideas did we come up with? It has no clue." },
];

export const FEATURE: ScriptLine[] = [
  { scene: "feature", fromSec: 0.4, holdSec: 5.5, caption: "So we wired the missions into memory." },
  { scene: "feature", fromSec: 6, holdSec: 6, caption: "The moment a mission finishes, its output files itself into the searchable library." },
  { scene: "feature", fromSec: 12.2, holdSec: 5.5, caption: "No button, no copy and paste. The same indexing an uploaded document gets." },
];

export const CORRECTION: ScriptLine[] = [
  { scene: "correction", fromSec: 0.4, holdSec: 5, caption: "The first version had a Save to Knowledge Base button you had to click." },
  { scene: "correction", fromSec: 5.6, holdSec: 5, caption: "The feedback was blunt. Why is filing my own work my job?" },
  { scene: "correction", fromSec: 10.8, holdSec: 5, caption: "A brain that needs a human to press Save is not really a brain. So we made it automatic." },
];

export const BUG1: ScriptLine[] = [
  { scene: "bug1", fromSec: 0.4, holdSec: 4.5, caption: "Then we tested it for real. And it failed." },
  { scene: "bug1", fromSec: 5.2, holdSec: 5, caption: "The four sources were created with exactly the right names." },
  { scene: "bug1", fromSec: 10.4, holdSec: 4.5, caption: "But every one was empty. Zero chunks. A hollow shell with nothing to search." },
];

export const BUG2: ScriptLine[] = [
  { scene: "bug2", fromSec: 0.4, holdSec: 4, caption: "The trail was full of traps." },
  { scene: "bug2", fromSec: 4.6, holdSec: 4.5, caption: "A timezone bug said the data was made before the code existed. False alarm." },
  { scene: "bug2", fromSec: 9.4, holdSec: 4.5, caption: "The stored content looked empty, but that was just the worker freeing memory. False alarm." },
  { scene: "bug2", fromSec: 14.2, holdSec: 4, caption: "The real cause. The embeddings service was down for one minute. The circuit tripped." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.4, holdSec: 5.5, caption: "So we ran the real pipeline again, against the live data." },
  { scene: "fix", fromSec: 6.2, holdSec: 5.5, caption: "It chunked, it embedded, and all four sources filled. Every call came back healthy." },
  { scene: "fix", fromSec: 12, holdSec: 4, caption: "The ideas are now in the library. Ask the chat and it answers with a citation." },
];

export const LEARNINGS: ScriptLine[] = [
  { scene: "learnings", fromSec: 0.4, holdSec: 4.5, caption: "Two lessons stuck." },
  { scene: "learnings", fromSec: 5.2, holdSec: 5, caption: "One. It compiles and passes tests is not the same as it works. Prove it on real data." },
  { scene: "learnings", fromSec: 10.6, holdSec: 5, caption: "Two. When you write data, expect the thing downstream to be down for a minute. Build for it." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Every mission your team runs now leaves a trace the whole team can ask about." },
  { scene: "outro", fromSec: 5.6, holdSec: 4.5, caption: "The tool stops just doing tasks. The system starts compounding knowledge." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
